import { CooldownAbility } from './CooldownAbility'

export function HordeTribute({ cost }) {
	return (
		<div
			className="flex flex-row w-[84px] h-[40px] justify-center border-solid border"
			style={{
				backgroundImage: `url(/liveGameIcons/BACKGROUND.png)`,
				borderColor: 'var(--main-color)',
			}}
		>
			<div className="flex flex-col text-center my-auto w-[44px] text-white">
				{cost}
			</div>
			<div className="h-[38px] w-[38px]">
				<CooldownAbility
					sizing="h-[38px] w-[38px]"
					icon={'/liveGameIcons/unique/horde/rus_tributes.png'}
				/>
			</div>
		</div>
	)
}
